<template>
  <div id="gotop" class="animated fadeInUp" @click="gotoTop" ref="gotop">
    <span>TOP</span>
  </div>
</template>

<script>
export default {
  name: "gotop",
  components: {},
  props: {},
  data() {
    return {};
  },
  methods: {
    gotoTop() {
      const vm = this;
      let discount;
      let timer = setInterval(function() {
        discount = window.scrollY - 100;
        if (window.scrollY < 100) {
          clearInterval(timer);
        }
        window.scrollTo(0, discount);
      }, 30);
    },
    winScroll() {
      const vm = this;
      const scrollY = window.scrollY;
      setTimeout(function() {
        if (scrollY > 100) {
          vm.$refs.gotop.classList.add("active");
        } else {
          vm.$refs.gotop.classList.remove("active");
        }
      }, 100);
    }
  },
  computed: {},
  created() {},
  mounted() {
    // console.log(window.scrollY);
    const vm = this;
    vm.winScroll();
    document.addEventListener("scroll", vm.winScroll);
  },
  watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
#gotop {
  position: fixed;
  bottom: 50px;
  right: 20px;
  background-color: #ee8b59;
  color: #fff;
  /* display: flex; */
  display: none;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.35s;
  z-index: 100;
  -moz-user-select: none; /* for Firefox */
  -webkit-user-select: none; /* for Chrome */
  user-select: none;
}
#gotop.active {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/gotop/index.vue